// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1687428608874
      var cssReload = require("/home/roxx/Pulpit/Local/drirenaeris/app/public/wp-content/themes/dr-irena-eris/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  